/* SHAY-INDUSTRY — thème Shopify : menu, panier (API AJAX Shopify), fiche produit, animations */
(function () {
  const CFG = window.SHAY_CFG || { freeShip: 8000, routes: { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' } };
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const eur = cents => (cents / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const imgSize = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  // ---------- Toast ----------
  const toast = msg => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('on'), 2600);
  };

  // ---------- Menu + panier ----------
  const drawer = $('[data-drawer]'), overlay = $('[data-overlay]'), menu = $('[data-menu]');
  const lock = () => document.documentElement.classList.toggle('locked', drawer.classList.contains('on') || menu.classList.contains('open'));
  function openCart() { closeMenu(); drawer.classList.add('on'); overlay.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); lock(); }
  function closeCart() { drawer.classList.remove('on'); overlay.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); lock(); }
  function openMenu() { menu.classList.add('open'); menu.setAttribute('aria-hidden', 'false'); lock(); }
  function closeMenu() { menu.classList.remove('open'); menu.setAttribute('aria-hidden', 'true'); lock(); }
  menu.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  matchMedia('(min-width:981px)').addEventListener('change', e => { if (e.matches) closeMenu(); });

  // ---------- Panier Shopify ----------
  let cart = { items: [], item_count: 0, total_price: 0 };
  const api = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined
  }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });

  const lineHTML = (l, big) => `
    <div class="line"${big ? ' style="grid-template-columns:110px 1fr auto"' : ''}>
      <a href="${esc(l.url)}"><img src="${esc(imgSize(l.image, 300))}" alt="${esc(l.product_title)}"${big ? ' style="width:110px"' : ''}></a>
      <div>
        <div class="n">${esc(l.product_title)}</div>
        <div class="v">${l.variant_title ? esc(l.variant_title) : ''}</div>
        <div class="qty"><button data-dec="${esc(l.key)}" aria-label="Moins">−</button><span>${l.quantity}</span><button data-inc="${esc(l.key)}" aria-label="Plus">+</button></div>
        <button class="rm" data-rm="${esc(l.key)}">Retirer</button>
      </div>
      <div>${eur(l.final_line_price)}</div>
    </div>`;
  const emptyHTML = `<div class="empty"><p class="h3">Ton panier est vide.</p><p>Laisse-toi tenter par la nouvelle collection.</p><br><a class="btn" href="${CFG.routes.root}#collection">Découvrir la collection</a></div>`;

  function render() {
    $$('[data-count]').forEach(el => (el.textContent = cart.item_count));
    const t = cart.total_price, left = Math.max(0, CFG.freeShip - t);
    $('[data-ship]').innerHTML = (left > 0 ? `Plus que <b>${eur(left)}</b> pour la livraison offerte` : `<b>Livraison offerte</b> débloquée ✦`) +
      `<div class="bar"><i style="width:${Math.min(100, (t / CFG.freeShip) * 100)}%"></i></div>`;
    $('[data-lines]').innerHTML = cart.items.length ? cart.items.map(l => lineHTML(l)).join('') : emptyHTML;
    $('[data-cart-foot]').innerHTML = cart.items.length ? `<div class="tot"><span>Sous-total</span><b>${eur(t)}</b></div>
      <small>Taxes incluses. Frais de port calculés au paiement. Retrait gratuit à Angers.</small>
      <a class="btn block" href="/checkout">Passer commande</a>
      <a href="${CFG.routes.cart}" class="link" style="display:block;text-align:center;margin-top:14px;border:0">Voir le panier</a>` : '';
    // Page panier
    const list = $('[data-cart-list]');
    if (list) {
      list.innerHTML = cart.items.length ? cart.items.map(l => lineHTML(l, true)).join('') : emptyHTML.replace('Laisse-toi tenter par la nouvelle collection.', '');
      $('[data-sub]').textContent = eur(t);
      const co = $('[data-checkout]'); if (co) co.style.display = cart.items.length ? '' : 'none';
    }
  }
  const refresh = () => api(CFG.routes.cart + '.js').then(c => { cart = c; render(); }).catch(() => render());
  function add(items) {
    return api(CFG.routes.add + '.js', { items }).then(() => refresh()).then(openCart)
      .catch(err => toast(/stock|disponible|available|sold/i.test(err.message) ? 'Cet article n\'est plus disponible' : 'Oups, réessaie dans un instant'));
  }
  function change(key, quantity) { return api(CFG.routes.change + '.js', { id: key, quantity }).then(c => { cart = c; render(); }).catch(() => toast('Quantité indisponible')); }
  const qtyOf = key => (cart.items.find(l => l.key === key) || {}).quantity || 0;

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open-cart],[data-close-cart],[data-overlay],[data-inc],[data-dec],[data-rm],[data-open-menu],[data-close-menu],[data-quick-add]');
    if (!t) return;
    if (t.matches('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (t.matches('[data-close-cart],[data-overlay]')) closeCart();
    if (t.matches('[data-inc]')) change(t.dataset.inc, qtyOf(t.dataset.inc) + 1);
    if (t.matches('[data-dec]')) change(t.dataset.dec, qtyOf(t.dataset.dec) - 1);
    if (t.matches('[data-rm]')) change(t.dataset.rm, 0);
    if (t.matches('[data-open-menu]')) openMenu();
    if (t.matches('[data-close-menu]')) closeMenu();
    if (t.matches('[data-quick-add]')) { e.preventDefault(); add([{ id: +t.dataset.quickAdd, quantity: 1 }]); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeMenu(); } });
  window.SHAY = { add, refresh, toast, eur };

  // ---------- Fiche produit ----------
  const pdp = $('[data-pdp]'), pjson = $('[data-product-json]');
  if (pdp && pjson) {
    const data = JSON.parse(pjson.textContent);
    let variant = data.variants.find(v => v.id === data.current) || data.variants[0];
    let qty = 1;
    const sel = [...variant.options];

    // Galerie
    const main = $('[data-main]'), thumbs = $$('[data-t]');
    let gi = Math.max(0, thumbs.findIndex(b => b.classList.contains('on')));
    function show(i) {
      if (!thumbs.length) return;
      gi = (i + thumbs.length) % thumbs.length;
      main.style.opacity = 0;
      setTimeout(() => { main.src = thumbs[gi].dataset.src; main.style.opacity = 1; }, 150);
      thumbs.forEach((b, k) => b.classList.toggle('on', k === gi));
    }
    thumbs.forEach((b, k) => b.addEventListener('click', () => show(k)));
    $$('[data-g]').forEach(b => b.addEventListener('click', () => show(gi + +b.dataset.g)));
    if (main) {
      let tx = 0;
      main.parentElement.addEventListener('touchstart', e => tx = e.touches[0].clientX, { passive: true });
      main.parentElement.addEventListener('touchend', e => { const d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 40) show(gi + (d < 0 ? 1 : -1)); });
    }

    // Options → variante
    const sizesEl = $('[data-sizes]'), offersEl = $('[data-offers]'), colorsEl = $('[data-colors]'), stickySize = $('[data-sticky-size]');
    // Grise les valeurs d'une option qui n'existent pas (ou sont épuisées) avec le reste de la sélection
    function dim(el, valOf) {
      if (el) $$('button', el).forEach(b => {
        const test = [...sel]; test[+el.dataset.pos - 1] = valOf(b);
        const v = data.variants.find(x => x.options.every((o, i) => o === test[i]));
        b.style.opacity = v && v.available ? '' : '.4';
      });
    }
    function pick() {
      variant = data.variants.find(v => v.options.every((o, i) => o === sel[i])) || variant;
      const total = variant.price * qty;
      $$('[data-price],[data-sticky-price]').forEach(el => (el.textContent = eur(total)));
      const ok = variant.available;
      $$('[data-add],[data-sticky-add]').forEach(b => { b.disabled = !ok; b.textContent = ok ? 'Ajouter au panier' : 'Épuisé'; });
      dim(sizesEl, b => b.textContent);
      dim(colorsEl, b => b.dataset.val);
    }
    function setSize(val) {
      if (!sizesEl) return;
      sel[+sizesEl.dataset.pos - 1] = val;
      $$('button', sizesEl).forEach(x => x.classList.toggle('on', x.textContent === val));
      const n = $('[data-size-name]'); if (n) n.textContent = val;
      if (stickySize) stickySize.value = val;
      pick();
    }
    if (sizesEl) sizesEl.addEventListener('click', e => { const b = e.target.closest('button'); if (b) setSize(b.textContent); });
    if (stickySize) stickySize.addEventListener('change', () => setSize(stickySize.value));
    if (colorsEl) colorsEl.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      sel[+colorsEl.dataset.pos - 1] = b.dataset.val;
      $$('button', colorsEl).forEach(x => x.classList.toggle('on', x === b));
      const n = $('[data-color-name]'); if (n) n.textContent = b.dataset.val;
      pick();
      // Affiche la photo de la couleur choisie si elle est liée à la variante
      const img = variant.featured_image && variant.featured_image.src;
      if (img && main) {
        const file = img.split('/').pop().split('?')[0];
        const k = thumbs.findIndex(t => t.dataset.src.includes(file));
        if (k >= 0) show(k); else main.src = img;
      }
    });
    if (offersEl) $$('.offer', offersEl).forEach(o => o.addEventListener('click', () => {
      $$('.offer', offersEl).forEach(x => x.classList.toggle('on', x === o));
      sel[+offersEl.dataset.pos - 1] = o.dataset.val;
      pick();
    }));
    $$('[data-q]').forEach(b => b.addEventListener('click', () => { qty = Math.max(1, qty + +b.dataset.q); $('[data-qv]').textContent = qty; pick(); }));
    const addBtn = $('[data-add]');
    const doAdd = btn => { btn.classList.add('is-loading'); add([{ id: variant.id, quantity: qty }]).finally(() => btn.classList.remove('is-loading')); };
    if (addBtn) addBtn.addEventListener('click', () => doAdd(addBtn));
    const stickyAdd = $('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', () => doAdd(stickyAdd));
    const guide = $('[data-guide]');
    if (guide) guide.addEventListener('click', () => { $('#guide').open = true; });
    pick();

    // Barre d'achat collante
    if (addBtn && $('[data-sticky]')) {
      const io = new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; $('[data-sticky]').classList.toggle('on', on); document.documentElement.classList.toggle('atc-on', on); });
      io.observe(addBtn);
    }
  }

  // ---------- Matières & avantages (Manteau) ----------
  const mxData = $('[data-mx-data]');
  if (mxData) {
    const mx = JSON.parse(mxData.textContent), MX_MS = 6000;
    let mi = 0, mxTimer;
    const mxTabs = $$('[data-mx-tabs] button'), mxImg = $('[data-mx-img]'), mxBar = $('[data-mx-bar]');
    function mxShow(i) {
      mi = (i + mx.length) % mx.length;
      const [word, src, origin, scale, desc] = mx[mi];
      mxTabs.forEach((b, k) => { b.classList.toggle('on', k === mi); b.setAttribute('aria-selected', k === mi); });
      $('[data-mx-word]').textContent = word;
      mxImg.style.opacity = 0;
      setTimeout(() => { mxImg.src = src; mxImg.style.transformOrigin = origin; mxImg.style.transform = `scale(${scale})`; mxImg.style.opacity = 1; }, 250);
      $('[data-mx-desc]').innerHTML = desc;
      mxBar.style.transition = 'none'; mxBar.style.width = '0';
      requestAnimationFrame(() => requestAnimationFrame(() => { mxBar.style.transition = `width ${MX_MS}ms linear`; mxBar.style.width = '100%'; }));
      clearTimeout(mxTimer); mxTimer = setTimeout(() => mxShow(mi + 1), MX_MS);
    }
    mxTabs.forEach((b, k) => b.addEventListener('click', () => mxShow(k)));
    $$('[data-mx-go]').forEach(b => b.addEventListener('click', () => mxShow(mi + +b.dataset.mxGo)));
    const all = $('[data-mx-all]'); if (all) all.addEventListener('click', () => { $('#matiere-entretien').open = true; });
    mxShow(0);
  }

  // ---------- Carrousels glissables ----------
  $$('[data-carousel]').forEach(car => {
    let down = false, sx = 0, sl = 0, moved = false;
    car.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.pageX; sl = car.scrollLeft; car.classList.add('drag'); });
    window.addEventListener('pointerup', () => { down = false; car.classList.remove('drag'); });
    car.addEventListener('pointermove', e => { if (!down) return; const dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; car.scrollLeft = sl - dx; });
    car.addEventListener('click', e => { if (moved) e.preventDefault(); }, true);
  });

  // ---------- Apparition au scroll ----------
  const io = new IntersectionObserver(es => es.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('vis'); io.unobserve(en.target); }
  }), { threshold: .12 });
  $$('.rv-in').forEach(el => io.observe(el));

  // Retour après envoi d'un formulaire Shopify : on se recale sur le formulaire
  if (/[?&]customer_posted=true|[?&]contact_posted=true/.test(location.search) || location.hash === '#form-newsletter' || location.hash === '#form-contact') {
    addEventListener('load', () => (document.getElementById(location.hash.slice(1)) || $('#newsletter'))?.scrollIntoView({ behavior: 'instant', block: 'center' }));
  } else if (location.hash.length > 1) {
    addEventListener('load', () => document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'instant' }));
  }

  render();
  refresh();
})();
